import React, { useState } from 'react';
import { CircularProgress, Switch } from '@mui/material';
import { useSelector } from 'react-redux';
import { usePolicies } from './useCPData';
import cpApi from './cpApi';
import './ArtemyStyles.css';

export default function PolicyEngine() {
  const { user } = useSelector((s) => s.auth);
  const { policies, loading, refetch } = usePolicies();
  const [toggling, setToggling] = useState(null);
  const orgCode = user?.data?.[0]?.client_code || '';

  const handleToggle = async (policy) => {
    setToggling(policy.policy_id);
    try {
      await cpApi.updatePolicy({ org_code: orgCode, policy_id: policy.policy_id, enabled: !policy.enabled });
      refetch();
    } catch (e) {
      console.error(e);
    } finally {
      setToggling(null);
    }
  };

  return (
    <div className="artemy-fade-up">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 22 }}>
        <div>
          <div className="artemy-page-title">Policy Engine</div>
          <div className="artemy-page-sub">Governance rules for delivery automation and agent behaviour</div>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 14, marginBottom: 16 }}>
        {[
          { label: 'Total Policies', value: policies.length, color: 'var(--artemy-text-primary)' },
          { label: 'Active', value: policies.filter((p) => p.enabled).length, color: 'var(--artemy-green)' },
          { label: 'Inactive', value: policies.filter((p) => !p.enabled).length, color: 'var(--artemy-text-dim)' },
        ].map((m) => (
          <div key={m.label} className="artemy-card" style={{ padding: 16 }}>
            <div style={{ fontFamily: 'var(--artemy-font-mono)', fontSize: 11, color: 'var(--artemy-text-secondary)', marginBottom: 7 }}>{m.label}</div>
            <div style={{ fontFamily: 'var(--artemy-font-display)', fontSize: 26, fontWeight: 700, color: m.color }}>{m.value}</div>
          </div>
        ))}
      </div>

      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 32 }}><CircularProgress size={28} sx={{ color: 'var(--artemy-accent)' }} /></div>
      ) : policies.length === 0 ? (
        <div style={{ textAlign: 'center', paddingTop: 32, color: 'var(--artemy-text-dim)', fontSize: 13 }}>No policies configured yet</div>
      ) : (
        policies.map((p) => (
          <div key={p.policy_id} className="artemy-card" style={{ padding: '14px 20px', marginBottom: 10, display: 'grid', gridTemplateColumns: '1fr auto', alignItems: 'center', gap: 14, cursor: 'default' }}>
            <div>
              <div style={{ fontSize: 13.5, fontWeight: 600, marginBottom: 3, color: 'var(--artemy-text-primary)' }}>{p.name}</div>
              <div style={{ fontSize: 12, color: 'var(--artemy-text-secondary)', lineHeight: 1.4 }}>{p.description}</div>
              {p.updated_at && (
                <div style={{ marginTop: 7, fontFamily: 'var(--artemy-font-mono)', fontSize: 10.5, color: 'var(--artemy-text-dim)', opacity: .8 }}>
                  Last updated {new Date(p.updated_at).toLocaleDateString()}
                </div>
              )}
            </div>
            <Switch
              checked={Boolean(p.enabled)}
              disabled={toggling === p.policy_id}
              onChange={() => handleToggle(p)}
              sx={{
                '& .MuiSwitch-switchBase.Mui-checked': { color: 'var(--artemy-accent)' },
                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: 'var(--artemy-accent)' },
              }}
            />
          </div>
        ))
      )}
      <div style={{ height: 40 }} />
    </div>
  );
}
